import { Stack, Tooltip, Typography } from "@mui/material";

import config from "../../config";

const Footer = () => {
  return (
    <Stack
      component="footer"
      direction="row"
      marginTop="auto"
      alignItems="center"
      justifyContent="space-between"
    >
      <Tooltip title={`${config.env}, ${config.version}`}>
        <Typography variant="body2" align="center" p={1}>
          INTEGRITY © {new Date().getFullYear()}
        </Typography>
      </Tooltip>
    </Stack>
  );
};

export default Footer;
